import { styled } from "@mui/material/styles";

export const Label = styled("label")(({ theme }) => ({
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px"
}));
